import React from "react";

import copy from "../../data/copy.js";

const IMAGE_FOLDER_PATH_SM = "resources/images_docs/small";
const IMAGE_FOLDER_PATH_MD = "resources/images_docs/medium";
const IMAGE_FOLDER_PATH_XL = "resources/images_docs/large";

export default class CabinetImageViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImg: this.props.selectedImg
    };
  }

  renderImage() {
    const selectedImg = this.state.selectedImg;

    const title =
      selectedImg["title_" + this.props.languageId] || "Unknown title";
    const description =
      selectedImg["description_" + this.props.languageId] ||
      "Unknown description";

    if (selectedImg) {
      const filenamePNG = `${selectedImg.filename.split(".")[0]}.png`;
      return (
        <div>
          <div className="img-viewer">
            <p>{title}</p>
            <img src={`${IMAGE_FOLDER_PATH_MD}/${filenamePNG}`} />
            <p className="description">{description}</p>
          </div>
          <div className="actions">
            <div className="document-action action">
              <button>
                <a
                  target="_blank"
                  href={`${IMAGE_FOLDER_PATH_XL}/${filenamePNG}`}
                >
                  Download full-sized image
                </a>
              </button>
            </div>
          </div>
        </div>
      );
    }
    return "";
  }

  render() {
    console.log(this.props.images);
    return (
      <div>
        <h2>{this.props.title}</h2>
        <div className="img-directory">
          <div className="thumbnails">
            {this.props.images.map(doc => {
              const isSelected =
                this.state.selectedImg.filename === doc.filename;
              return (
                <div key={`wrap-${doc.filename}`} className="img-wrapper">
                  <div
                    className={`img ${isSelected ? "selected" : ""}`}
                    onClick={() => {
                      this.setState({ selectedImg: doc });
                    }}
                    style={{
                      backgroundImage: `url('${IMAGE_FOLDER_PATH_SM}/${
                        doc.filename
                      }')`
                    }}
                  />
                </div>
              );
            })}
          </div>
          {this.renderImage()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./application/frontend/src/containers/cabinet/CabinetImageViewer.jsx